import DataList from "components/datatable/DataList";
import React, { useMemo } from "react";
import useAxios from "hooks/useAxios";
import useAxiosFunction from "hooks/useAxiosFunction";
import { useAuth } from "context/AuthProvider";
import { RuleRequired } from "utils/MyUtils";
import { boolText, hasPermission, showEmpty } from "./SystemPageUtils";

export default function UserContextManagementPage() {
  const { user } = useAuth();
  const [usersResp] = useAxios({ method: "GET", url: "/system/users", auth: true });
  const [groupsResp] = useAxios({ method: "GET", url: "/system/groups", auth: true });
  const [, , , axiosFetch] = useAxiosFunction();
  const canManage = hasPermission(user, "system.user.manage");

  const users = Array.isArray(usersResp?.data) ? usersResp.data : [];
  const groups = Array.isArray(groupsResp?.data) ? groupsResp.data : [];

  const coltype = useMemo(
    () => ({
      id_user_group: { type: "hidden", name: "id_user_group" },
      id_user: {
        label: "User",
        type: "dropdown",
        name: "id_user",
        colsize: 6,
        validation: RuleRequired,
        options: users,
        valueId: "id_user",
        labelId: "username",
        placeholder: "-Pilih User-",
      },
      id_group: {
        label: "Group",
        type: "dropdown",
        name: "id_group",
        colsize: 6,
        validation: RuleRequired,
        options: groups,
        valueId: "id_group",
        labelId: "groupname",
        placeholder: "-Pilih Group-",
      },
      context_type: {
        label: "Context Type",
        type: "text",
        name: "context_type",
        colsize: 4,
        renderFunc: (val) => showEmpty(val),
        width: 150,
      },
      context_id: {
        label: "Context ID",
        type: "text",
        name: "context_id",
        colsize: 4,
        renderFunc: (val) => showEmpty(val),
        width: 180,
      },
      valid_until: {
        label: "Valid Until",
        type: "text",
        name: "valid_until",
        colsize: 4,
        placeholder: "2026-12-31T23:59:59+07",
        renderFunc: (val) => showEmpty(val),
        width: 180,
      },
      is_active: {
        label: "Status",
        type: "checkbox",
        name: "is_active",
        colsize: 2,
        renderFunc: (val) => boolText(val),
        width: 100,
        align: "center",
      },
      username: { label: "Username", width: 180 },
      groupname: { label: "Group", width: 180 },
      action: { label: "Aksi", align: "center", width: 100 },
    }),
    [groups, users]
  );

  const saveUserContext = async (form, defaultValue = {}) => {
    const id = form?.id_user_group || defaultValue?.id_user_group || "";
    const method = id ? "PUT" : "POST";
    const url = id ? `/system/user-contexts/${id}` : "/system/user-contexts";

    return axiosFetch({
      method,
      url,
      auth: true,
      data: {
        id_user: form.id_user,
        id_group: Number(form.id_group || 0),
        context_type: form.context_type || "",
        context_id: form.context_id || "",
        valid_until: form.valid_until || "",
        is_active: Boolean(form.is_active),
      },
    });
  };

  return (
    <DataList
      title="Daftar User Context"
      coltype={coltype}
      dlist={{
        url: "/system/user-contexts",
        columns: ["no", "username", "groupname", "context_type", "context_id", "valid_until", "is_active", "action"],
        filter: [{ dtype: "q", name: "q", colsize: 4 }],
        sort_by: ["username", "groupname", "context_type", "context_id"],
      }}
      addconfig={canManage ? {
        columns: ["id_user", "id_group", "is_active", "context_type", "context_id", "valid_until"],
        title: "Penambahan User Context",
        label_tool: "Tambah User Context",
        saveHandle: saveUserContext,
      } : null}
      editconfig={canManage ? {
        columns: ["id_user_group", "id_user", "id_group", "is_active", "context_type", "context_id", "valid_until"],
        title: "Perubahan User Context",
        url: "/system/user-contexts",
        urlitem: "/system/user-contexts",
        cellid: "id_user_group",
        saveHandle: saveUserContext,
        normalizeItem: (item) => ({
          ...item,
          id_group: item?.id_group ? String(item.id_group) : "",
          is_active: parseBoolean(item?.is_active),
        }),
      } : null}
      delconfig={canManage ? {
        url: "/system/user-contexts",
        cellid: "id_user_group",
        cellname: "username",
      } : null}
    />
  );
}
